{
  "wordmarkHome": "سحاب — الرئيسية",
  "poweredBy": "بدعم من",
  "menu": "فتح القائمة",
  "skipToContent": "تخطَّ إلى المحتوى",
  "breadcrumbs": "مسار التنقل",
  "back": "رجوع",
  "nav": {
    "label": "التنقل الرئيسي",
    "home": "الرئيسية",
    "approvals": "موافقاتي",
    "sales": "المبيعات",
    "customers": "العملاء",
    "customerGroups": "مجموعات العملاء",
    "administration": "الإدارة",
    "users": "المستخدمون",
    "roles": "الأدوار",
    "purchasing": "المشتريات",
    "suppliers": "الموردون",
    "supplierGroups": "مجموعات الموردين",
    "purchases": "فواتير الشراء",
    "supplierPayments": "مدفوعات الموردين",
    "supplierRefunds": "المبالغ المستردة من الموردين",
    "supplierReturns": "مرتجعات الموردين",
    "payablesAging": "أعمار الذمم الدائنة",
    "pointOfSale": "نقاط البيع",
    "posTill": "شاشة البيع",
    "posShifts": "الورديات",
    "posTills": "الصناديق",
    "loyalty": "الولاء",
    "loyaltyOverview": "نظرة عامة",
    "loyaltyMembers": "الأعضاء",
    "loyaltyTransactions": "حركات النقاط",
    "loyaltyProgram": "البرنامج",
    "accounting": "المحاسبة",
    "chartOfAccounts": "دليل الحسابات",
    "journalEntries": "القيود اليومية",
    "trialBalance": "ميزان المراجعة",
    "fiscalYears": "السنوات المالية",
    "accountMapping": "ربط الحسابات",
    "cashBank": "النقدية والبنوك",
    "cheques": "الشيكات",
    "transfers": "التحويلات",
    "expensesGroup": "المصروفات",
    "expenses": "المصروفات",
    "expenseCategories": "الفئات",
    "recurringExpenses": "المتكررة",
    "taxRates": "نسب الضريبة",
    "quotations": "عروض الأسعار",
    "invoices": "الفواتير",
    "creditNotes": "الإشعارات الدائنة",
    "receipts": "سندات القبض",
    "refunds": "المبالغ المستردة",
    "receivablesAging": "أعمار الذمم المدينة",
    "auditLog": "سجل التدقيق",
    "privacyRequests": "طلبات الخصوصية",
    "settings": "الإعدادات",
    "inventory": "المخزون",
    "products": "المنتجات",
    "productCategories": "فئات المنتجات",
    "units": "الوحدات",
    "attributes": "الخصائص",
    "warehouses": "المستودعات",
    "stockLevels": "أرصدة المخزون",
    "stockMovements": "حركات المخزون",
    "serials": "الأرقام التسلسلية",
    "stockAdjustments": "تسويات المخزون",
    "stockTransfers": "تحويلات المخزون",
    "profitAndLoss": "الأرباح والخسائر",
    "balanceSheet": "الميزانية العمومية",
    "generalLedger": "دفتر الأستاذ العام",
    "vatReturn": "إقرار ضريبة القيمة المضافة",
    "reports": "التقارير",
    "cashFlow": "التدفقات النقدية",
    "booksHealth": "سلامة الدفاتر",
    "salesByCustomer": "المبيعات حسب العميل",
    "salesByProduct": "المبيعات حسب المنتج",
    "salesByPeriod": "المبيعات حسب الفترة",
    "salesByUser": "المبيعات والتحصيلات حسب المستخدم",
    "purchasesBySupplier": "المشتريات حسب المورد",
    "purchasesByProduct": "المشتريات حسب المنتج",
    "stockValuation": "تقييم المخزون",
    "lowStock": "نواقص المخزون",
    "posSummary": "ملخص مبيعات نقاط البيع",
    "bankStatements": "التسوية البنكية",
    "work": "العمل",
    "myWork": "أعمالي",
    "tasks": "المهام",
    "teams": "الفرق",
    "taskReport": "إنجاز المهام",
    "projectProfitability": "ربحية المشاريع",
    "projectBudgetVsActual": "موازنة المشاريع مقابل الفعلي",
    "projectUnbilledWork": "أعمال المشاريع غير المفوترة",
    "projectUtilisation": "استخدام وقت الفريق",
    "calendar": "التقويم",
    "service": "الخدمة",
    "serviceOverview": "لوحة الخدمة",
    "serviceJobs": "أوامر الخدمة",
    "serviceSchedule": "جدول الزيارات",
    "serviceMyVisits": "زياراتي",
    "serviceFollowUps": "طلبات المتابعة",
    "serviceCollections": "التحصيلات",
    "serviceSites": "المواقع والمعدات",
    "serviceContracts": "عقود الصيانة",
    "projects": "المشاريع",
    "projectsPortfolio": "محفظة المشاريع",
    "projectMaterialIssues": "صرف المواد",
    "projectCostEntries": "قيود التكاليف",
    "projectReconciliation": "مطابقة حسابات العقود",
    "projectGuarantees": "الضمانات",
    "projectTime": "وقتي",
    "projectTimeApprovals": "اعتماد الوقت",
    "projectRates": "تكلفة الساعة",
    "projectStatusReports": "تقارير الحالة",
    "serviceContractBilling": "فوترة العقود",
    "serviceContractInsights": "مؤشرات العقود",
    "hr": "الموارد البشرية",
    "hrDashboard": "لوحة الموارد البشرية",
    "hrEmployees": "الموظفون",
    "hrDocuments": "انتهاء الوثائق",
    "hrPayComponents": "عناصر الراتب",
    "payroll": "الرواتب",
    "payrollRuns": "كشوف الرواتب",
    "payrollContributions": "نسب الاشتراكات",
    "payrollSettings": "إعدادات الرواتب",
    "salesBySalesperson": "المبيعات حسب مندوب المبيعات",
    "commissions": "العمولات",
    "commissionRuns": "كشوف العمولات",
    "commissionPlans": "خطط العمولات",
    "myCommission": "عمولتي"
  },
  "crumbs": {
    "projectClaim": "المستخلص",
    "projectReports": "تقارير الحالة",
    "projectReport": "تقرير الحالة",
    "privacyRequest": "الطلب",
    "newCustomer": "عميل جديد",
    "approvalRequest": "الطلب",
    "edit": "تعديل",
    "changePassword": "تغيير كلمة المرور",
    "newUser": "مستخدم جديد",
    "newRole": "دور جديد",
    "newSupplier": "مورد جديد",
    "newJournal": "قيد جديد",
    "newExpense": "مصروف جديد",
    "newRecurringExpense": "مصروف متكرر جديد",
    "newInvoice": "فاتورة جديدة",
    "newDebitNote": "إشعار مدين جديد",
    "newQuotation": "عرض سعر جديد",
    "newReceipt": "سند قبض جديد",
    "newCreditNote": "إشعار دائن جديد",
    "print": "طباعة",
    "estimate": "عرض السعر",
    "visitReport": "تقرير الزيارة",
    "labels": "الملصقات",
    "assetLabels": "ملصقات المعدّات",
    "newContract": "عقد جديد",
    "newProduct": "منتج جديد",
    "newStockAdjustment": "تسوية مخزون جديدة",
    "newPurchase": "فاتورة شراء جديدة",
    "newSupplierPayment": "دفعة جديدة",
    "newSupplierReturn": "مرتجع جديد",
    "newRefund": "استرداد الرصيد",
    "newStockTransfer": "تحويل مخزون جديد",
    "newSupplierRefund": "تسجيل استرداد",
    "newBankStatement": "كشف جديد",
    "workflows": "مسارات الاعتماد",
    "approvalRuns": "طلبات الاعتماد",
    "approvalDelegations": "التفويضات",
    "newEmployee": "تعيين موظف",
    "newCommissionPlan": "خطة جديدة"
  },
  "sidebar": {
    "collapse": "طي الشريط الجانبي",
    "expand": "توسيع الشريط الجانبي"
  },
  "search": {
    "button": "بحث…",
    "label": "البحث والأوامر",
    "placeholder": "اكتب اسم شاشة أو أمرًا…",
    "empty": "لا توجد نتائج.",
    "serviceJobs": "أوامر الخدمة",
    "findAsset": "البحث عن معدّة برمزها التعريفي",
    "goTo": "الانتقال إلى",
    "thisPage": "هذه الصفحة",
    "actions": "إجراءات",
    "preferences": "التفضيلات",
    "account": "الحساب",
    "newCustomer": "عميل جديد",
    "theme": "المظهر: {{theme}}",
    "newUser": "مستخدم جديد",
    "newRole": "دور جديد",
    "newSupplier": "مورد جديد",
    "newJournal": "قيد يومية جديد",
    "newExpense": "مصروف جديد",
    "newInvoice": "فاتورة جديدة",
    "newQuotation": "عرض سعر جديد",
    "newReceipt": "تسجيل سند قبض",
    "newCreditNote": "إشعار دائن جديد",
    "newProduct": "منتج جديد",
    "newStockAdjustment": "تسوية مخزون جديدة",
    "newPurchase": "فاتورة شراء جديدة",
    "newSupplierPayment": "دفع مبلغ لمورد",
    "newSupplierReturn": "مرتجع مورد جديد",
    "newRefund": "استرداد رصيد عميل",
    "openTill": "فتح شاشة البيع",
    "newStockTransfer": "تحويل مخزون جديد",
    "reports": "التقارير",
    "newBankStatement": "كشف حساب بنكي جديد",
    "newTask": "مهمة جديدة",
    "newServiceJob": "أمر خدمة جديد",
    "newContract": "عقد صيانة جديد",
    "newProject": "مشروع جديد",
    "newEmployee": "تعيين موظف"
  },
  "language": {
    "label": "اللغة",
    "switchToArabic": "التبديل إلى العربية",
    "switchToEnglish": "التبديل إلى الإنجليزية",
    "arabic": "العربية",
    "english": "English"
  },
  "theme": {
    "label": "المظهر",
    "light": "فاتح",
    "dark": "داكن",
    "system": "حسب النظام"
  },
  "user": {
    "menu": "قائمة حساب {{name}}",
    "signOut": "تسجيل الخروج",
    "signedOut": "تم تسجيل الخروج",
    "changePassword": "تغيير كلمة المرور",
    "appearance": "المظهر",
    "myCommission": "عمولتي"
  },
  "home": {
    "greeting": {
      "morning": "صباح الخير، {{name}}",
      "afternoon": "مساء الخير، {{name}}",
      "evening": "مساء الخير، {{name}}"
    },
    "shortcuts": "ابدأ من هنا",
    "myWork": {
      "title": "أعمالي",
      "hint": "مهامك وزياراتك لهذا اليوم، وما ينتظر قرارك."
    },
    "newTask": {
      "title": "مهمة جديدة",
      "hint": "أسند عملًا إلى شخص أو فريق مع تاريخ استحقاق."
    },
    "serviceOverview": {
      "title": "نظرة عامة على الخدمة",
      "hint": "زيارات اليوم والأوامر المفتوحة وما يحتاج إلى قرار."
    },
    "myVisits": {
      "title": "زياراتي",
      "hint": "الزيارات المجدولة لك: ابدأها وأبلغ عنها وأنهها."
    },
    "findCustomer": {
      "title": "البحث عن عميل",
      "hint": "ابحث بالاسم أو الرمز أو رقم الهاتف، وافتح السجل."
    },
    "newCustomer": {
      "title": "إضافة عميل",
      "hint": "أنشئ سجل عميل مع جهات الاتصال والمجموعات."
    },
    "groups": {
      "title": "مجموعات العملاء",
      "hint": "اطّلع على تصنيف العملاء ومن ينتمي إلى كل مجموعة."
    },
    "noAccess": "لا توجد شاشات متاحة لك بعد.",
    "noAccessHint": "اطلب من مسؤول النظام منح حسابك صلاحية الوصول إلى الشاشات التي تحتاجها.",
    "modulesOff": "الأقسام التي تعمل فيها متوقفة لشركتك.",
    "modulesOffHint": "صلاحياتك محفوظة. اطلب من مسؤول النظام إعادة تشغيلها.",
    "paletteTip": "اضغط {{shortcut}} في أي مكان للانتقال إلى شاشة أو تنفيذ أمر.",
    "suppliers": {
      "title": "البحث عن مورد",
      "hint": "بيانات الاتصال والبنك للشركات التي تشتري منها."
    },
    "newExpense": {
      "title": "تسجيل مصروف",
      "hint": "إيجار أو كهرباء أو وقود: مع الضريبة، مدفوع نقدًا أو من البنك."
    },
    "newJournal": {
      "title": "ترحيل قيد يومية",
      "hint": "قيد يدوي متوازن المدين والدائن."
    },
    "trialBalance": {
      "title": "ميزان المراجعة",
      "hint": "الرصيد الافتتاحي والحركة والرصيد الختامي لكل حساب."
    },
    "newInvoice": {
      "title": "إنشاء فاتورة",
      "hint": "فوترة عميل: المنتجات بالاسم أو رمز الصنف أو الباركود، مع الضريبة."
    },
    "recordReceipt": {
      "title": "تسجيل سند قبض",
      "hint": "مبلغ مقبوض من عميل يُطبّق على فواتيره المفتوحة."
    },
    "newPurchase": {
      "title": "تسجيل فاتورة شراء",
      "hint": "فاتورة المورد عن البضاعة المستلمة: ترحيلها يُدخلها إلى المخزون."
    },
    "openTill": {
      "title": "فتح شاشة البيع",
      "hint": "البيع عند الكاونتر: امسح المنتج، استلم الدفعة، واطبع الإيصال."
    }
  },
  "dashboard": {
    "label": "أهم الأرقام",
    "asOf": "الأرقام حتى تاريخ",
    "today": "اليوم",
    "onDate": "بتاريخ {{date}}",
    "since": "من {{date}}",
    "sectionFailed": "تعذّر عرض هذه الأرقام.",
    "sales": {
      "title": "صافي المبيعات (قبل الضريبة)",
      "invoices_zero": "لا فواتير",
      "invoices_one": "فاتورة واحدة",
      "invoices_two": "فاتورتان",
      "invoices_few": "{{n}} فواتير",
      "invoices_many": "{{n}} فاتورة",
      "invoices_other": "{{n}} فاتورة",
      "monthToDate": "منذ بداية الشهر",
      "yearToDate": "السنة المالية حتى الآن",
      "last12Months": "آخر 12 شهرًا",
      "trendLabel": "صافي المبيعات شهريًا من {{from}} إلى {{to}}؛ آخر شهر {{latest}}",
      "subtitle": "بعد خصم الإشعارات الدائنة، قبل الضريبة"
    },
    "receivables": {
      "title": "الذمم المدينة",
      "total": "المستحق على العملاء",
      "overdue": "المتأخر عن موعد السداد",
      "mostOverdue": "الأكثر تأخرًا",
      "aging": "الذمم المدينة حسب العمر"
    },
    "payables": {
      "title": "الذمم الدائنة",
      "total": "المستحق للموردين",
      "overdue": "المتأخر عن موعد السداد",
      "dueNext7Days": "يستحق خلال الأيام السبعة القادمة",
      "overdueShort": "متأخر",
      "weekShort": "مستحق هذا الأسبوع",
      "laterShort": "لاحقًا"
    },
    "cash": {
      "title": "النقدية والبنوك",
      "total": "إجمالي النقدية والبنوك",
      "none": "لا توجد حسابات نقدية أو بنكية بعد."
    },
    "stock": {
      "title": "المخزون",
      "value": "قيمة المخزون بالتكلفة",
      "lowStock": "أصناف بلغت حد إعادة الطلب أو نزلت عنه",
      "shortfall": "النقص عن حد إعادة الطلب"
    },
    "projects": {
      "title": "المشاريع",
      "active": "المشاريع المفتوحة",
      "attention": "تحتاج إلى متابعة",
      "readyToBill": "جاهز للفوترة",
      "outstanding": "مستحق على العملاء",
      "all": "كل المشاريع",
      "retentionHeld": "المحتجزات لدى العملاء",
      "guaranteesExpiring": "ضمانات تنتهي خلال 30 يومًا"
    },
    "books": {
      "title": "سلامة الدفاتر",
      "critical": "حرج",
      "warning": "تحذير",
      "info": "ملاحظة",
      "checked": "جرت فحوص {{from}} – {{to}} في {{date}}",
      "notChecked": "لم تجرِ الفحوص بعد هذا الشهر"
    },
    "cheques": {
      "title": "الشيكات",
      "toDeposit": "للإيداع",
      "due": "مستحقة الصرف",
      "received": "الواردة",
      "issued": "الصادرة",
      "atBank": "لدى البنك",
      "late_zero": "لا شيكات متأخرة",
      "late_one": "تأخر صرف شيك واحد",
      "late_two": "تأخر صرف شيكين",
      "late_few": "تأخر صرف {{n}} شيكات",
      "late_many": "تأخر صرف {{n}} شيكًا",
      "late_other": "تأخر صرف {{n}} شيك",
      "postDated": "مؤجلة",
      "bounced": "مرتجعة، آخر 30 يومًا",
      "week": "تستحق هذا الأسبوع"
    },
    "pos": {
      "title": "نقاط البيع",
      "openShifts": "الورديات المفتوحة الآن",
      "net": "صافي مبيعات نقاط البيع (قبل الضريبة)",
      "sales_zero": "{{day}} · لا مبيعات",
      "sales_one": "{{day}} · عملية بيع واحدة",
      "sales_two": "{{day}} · عمليتا بيع",
      "sales_few": "{{day}} · {{n}} عمليات بيع",
      "sales_many": "{{day}} · {{n}} عملية بيع",
      "sales_other": "{{day}} · {{n}} عملية بيع",
      "returns": "مرتجعات نقاط البيع"
    },
    "top": {
      "customers": "أفضل العملاء",
      "products": "أفضل المنتجات",
      "period": "الفترة",
      "month": "الشهر",
      "year": "السنة",
      "noSales": "لا توجد مبيعات مرحّلة في هذه الفترة بعد.",
      "otherLines": "بنود أخرى",
      "margin": "هامش {{margin}}٪"
    },
    "latest": {
      "title": "أحدث الفواتير",
      "all": "كل الفواتير",
      "none": "لا توجد فواتير بعد. أنشئ فاتورتك الأولى.",
      "draft": "مسودة"
    }
  },
  "restricted": {
    "label": "غيّر كلمة المرور"
  }
}
